/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';
import { ChoiceModel } from 'core/models/elements/components/choice.model';

/**
 * @class Defines a multiple choices question.
 */
export class MultipleChoicesQuestionModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a multiple choices question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.choices = bo.choices?.map((x) => new ChoiceModel(x));
    this.displayNbChoicesAllowed = bo.display_nb_choices_allowed;
    this.displayMode = bo.display_mode;
    this.constrainNumberChoices = bo.constrain_number_choices;
    this.minChoices = bo.minimum_choices;
    this.maxChoices = bo.maximum_choices;
    this.subDisplayMode = bo.sub_display_mode;
  }
}
